import {Tailwind} from '@wandb/weave/components/Tailwind';
import {ApolloQueryResult} from 'apollo-client';
import React from 'react';

import {EntityQuery} from '../../generated/graphql';
import {TeamSettingsPageEntity} from '../../graphql/teamQuery';
import {useIsAdminModeActiveAndIsNotLocalEnv} from '../../util/admin';
import EntityRateLimits from './EntityRateLimits';
import EntityRunsV2Section from './EntityRunsV2Section';
import TeamPaidToggle from './TeamPaidToggle';

type TeamWBAdminProps = {
  entity: TeamSettingsPageEntity | EntityQuery['entity'];
  onUpdate: () => Promise<ApolloQueryResult<EntityQuery>>;
};

const TeamWBAdmin = ({entity, onUpdate}: TeamWBAdminProps) => {
  if (!useIsAdminModeActiveAndIsNotLocalEnv()) {
    return null;
  }

  return (
    <Tailwind>
      <div className="mb-20">
        <span className="mt-12 text-2xl text-moon-500">Admin</span>
        <div className="mt-12 text-lg text-moon-500">Paid status</div>
        <TeamPaidToggle entity={entity} onUpdate={onUpdate} />
        <div className="mt-12 text-lg text-moon-500">Rate limits</div>
        <EntityRateLimits entity={entity} onUpdate={onUpdate} />
        <div className="mt-12 text-lg text-moon-500">Runs V2</div>
        <EntityRunsV2Section entity={entity} />
      </div>
    </Tailwind>
  );
};

export default TeamWBAdmin;
